<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import agreementValidation from '@/mixins/agreementValidation'
import { agreementMajorityAge } from '@/lib/agreement/filters';
import {hasEditPermission,currentRoleLevelName,trialActiveForClients} from '@/mixins/roleLevelPermissions';

export function newChildId() {
	return 'child-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
}

export default {
	props: ['agreementData'],
	mixins:[validationMixin, agreementValidation],
	data(){
		return{
			isViewMode : !hasEditPermission('section-basics'),
			showLearnButton: ['client-level-1', 'client-level-2'].includes(currentRoleLevelName)
		}
	},
	created(){
		// Backfill ids for children created before ids existed. Mutates local
		// agreementData only
		if (!this.isViewMode && Array.isArray(this.agreementData && this.agreementData.children)) {
			this.agreementData.children.forEach((child) => {
				if (child && !child.id) this.$set(child, 'id', newChildId());
			});
		}
	},
	computed:{
		clientUserAgreement(){
			// return currentRoleLevelName == 'client-sharing-user' ? true : false;
			return trialActiveForClients() || currentRoleLevelName === 'client-sharing-user';
		},
		majorityAge(){
			return agreementMajorityAge(this.agreementData);
		}
	},
	validations:{
		agreementData:{
			children:{
				$each: {
					name: { 
						first:{
							required
						},
						last:{
							required
						}
					}, 
					birthdate:{
						required
					},
					pronouns:{
						required
					},
					ofTheRelationship:{
						required
					}
				},
			}
		}
	},
	methods:{
		newChildId,
		triggerValidation(){
			this.agreementData.children.map((child,index)=>{
				this.$refs[`child-input-${index}`].triggerValidation()
			})
		}
	}
};
</script>

<template>
	<b-card>
		<div slot="header" class="section-heading">
			<h4>Child Information</h4>
			<a href="#" onclick="Intercom('showArticle', 12885503)" v-if="this.showLearnButton">Learn &nbsp;<b-icon-book/></a>
		</div>

		<list-item
			v-slot="{ item: child, index:index }"
			v-model="agreementData.children"
			class="mb-5"
			new-label="Add Child"
			:object-prototype="
				() => {
					return { id: newChildId(),
						name: {
							first:'',
							last:'',
						},
						birthdate:'',
						pronouns:null,
						ofTheRelationship:null
					};
				}
			"
			:testid="'child-'"
			:disabled="isViewMode"
			:id="`child-information-`"
		>
			<child-input-group v-model="child" :testid="'child-'+index" :ref="'child-input-'+index" :disabled="isViewMode" :majority-age="majorityAge"/>
		</list-item>
		<additional-clauses
			v-if="!clientUserAgreement"
			v-model="agreementData.childrenDetails.additionalClauses" :testid="'child-add-clause-'"
			:disabled="isViewMode"
		/>
	</b-card>
</template>
